export const ASSETS_PATH = "/static"
export const TEHRAN_CENTER: [number, number] = [51.2075701, 35.7077714]
export const LISTING_PER_PAGE = 11
